import request from '../libs/request';

const res = 'Enum';

export default {
  query(enumType) {
    return request({
      url: `api/${res}/queryEnumItem`,
      method: 'get',
      params: {
        enumType
      }
    });
  }
};
